// Decides which payment methods UpgradeModal's Stripe checkout offers:
// WeChat Pay + Alipay in mainland China, card / Apple Pay / Google Pay
// everywhere else.
//
// Uses the browser's time zone rather than IP geolocation on purpose: many
// users in China browse through a VPN, which would make an IP lookup say
// "not China", while the device's time zone still reports Asia/Shanghai.
// Hong Kong (Asia/Hong_Kong) and Macau (Asia/Macau) are deliberately NOT
// included — cards are the norm there.
const MAINLAND_CHINA_TIME_ZONES = new Set([
  "Asia/Shanghai",
  "Asia/Chongqing",
  "Asia/Chungking",
  "Asia/Harbin",
  "Asia/Urumqi",
  "Asia/Kashgar",
  "PRC",
]);

export function isMainlandChina() {
  try {
    return MAINLAND_CHINA_TIME_ZONES.has(Intl.DateTimeFormat().resolvedOptions().timeZone);
  } catch {
    return false;
  }
}
